/** Active state for sidebar links (prefix routes for nested pages). */
export function isSidebarPathActive(currentPath: string, path: string): boolean {
  if (path === "/ticketing/report") {
    return currentPath.startsWith("/ticketing");
  }
  if (path === "/services") {
    return currentPath.startsWith("/services");
  }
  if (path === "/concierge") {
    return currentPath === "/concierge" || currentPath.startsWith("/concierge/");
  }
  return currentPath === path;
}
